// src/components/Layout/MainLayout.js
import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Sidebar from './Sidebar';
import useAuthStore from '../../store/authStore';
import { useSidebar } from '../../App';

const MainLayout = () => {
    const { fetchUser } = useAuthStore();
    const { collapsed, setCollapsed } = useSidebar();

    useEffect(() => {
        fetchUser();
    }, [fetchUser]);

    // Efekt pro přidání třídy k body
    useEffect(() => {
        // Pokud je sidebar otevřený na mobilním zařízení
        if (!collapsed && window.innerWidth < 992) {
            document.body.classList.add('sidebar-open');
        } else {
            document.body.classList.remove('sidebar-open');
        }
    }, [collapsed]);

    const handleBackdropClick = () => {
        if (window.innerWidth < 992) {
            setCollapsed(true);
        }
    };

    return (
        <div className={`main-container ${collapsed ? 'sidebar-collapsed' : ''}`}>
            <div className="sidebar-backdrop" onClick={handleBackdropClick}></div>
            <Sidebar />
            <div className="main-content">
                <Header />
                <div className="content-wrapper">
                    <Outlet />
                </div>
            </div>
        </div>
    );
};

export default MainLayout;